import { atomFamily } from "jotai-family";
import { atomWithDefault } from "jotai/utils";
import { isEqual } from "lodash-es";
import { config } from "../../../config";
import { getTokenAtom } from "../../../server/auth/store";
import { authHeader } from "../../../utils/auth-header";
import type { BrandTone } from "../../brand-kit/server/brand-tone-service";
import { debugLabel } from "../../generate/store";
import { selfDriving } from "../../self-driving/self-driving";

export const layoutConfigurationFamily = atomFamily(
  ({
    formatId,
    answer,
    imgNum,
    cacheBuster,
    fileId,
    brandTones,
    tone,
  }: {
    formatId: string;
    answer: string;
    imgNum: number;
    cacheBuster?: string;
    fileId?: string;
    brandTones: BrandTone[];
    tone?: string;
  }) =>
    debugLabel(
      `layoutConfigurationFamily(${formatId}, ${answer}, ${imgNum}, ${cacheBuster})`,
      atomWithDefault(async (get) => {
        const { getToken } = get(getTokenAtom);
        const token = await getToken();

        if (!token) return;

        const { data, error } = await selfDriving.POST("/multiformat/{formatId}/image/{imgNum}", {
          body: {
            description: answer,
            ...(fileId && { fileId }),
            ...(tone
              ? { toneSummary: brandTones.find((brand) => brand.id === tone)?.summary }
              : {}),
          },
          params: {
            path: { formatId, imgNum: imgNum.toString() },
            query: { model: config.gpt_model, cacheBuster },
          },
          ...authHeader(token),
        });

        if (error) {
          throw error;
        }

        return data;
      }),
    ),

  isEqual,
);
